export enum FaultsBackdropContainerEnum {
    FaultsHeader = "faults-header",
    FaultsChips  = "faults-chip",
    FaultsGrid   = "faults-grid",
    FaultsPlanHeader = "faults-plan-header",
    FaultsPlanFlyOut = "faults-plan-fly-out",
    FaultsPlanView = "faults-plan-view"
};
